import Group from 'components/utils/Group'
import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import BodyText from 'components/Luxkit/Typography/BodyText'
import LineAngleRightIcon from 'components/Luxkit/Icons/line/LineAngleRightIcon'
import BusinessTravellerStepCircle from './BusinessTravellerStepCircle'
import HorizontalContainerWithFadedOverflow from 'components/Common/HorizontalContainerWithFadedOverflow'
import { centreElementInView } from 'lib/window/scrollUtils'
import { rem } from 'polished'
import { objectEntries } from 'lib/object/objectUtils'

const StepLineAngleRightIcon = styled(LineAngleRightIcon)`
  color: ${props => props.theme.palette.neutral.default.five};
`

const StepsContainer = styled(HorizontalContainerWithFadedOverflow)`
  gap: ${rem(8)};
`

interface Props {
  steps: App.BusinessTraveller.BusinessSignupSteps;
  stepStatuses: App.BusinessTraveller.BusinessSignupStepKeyStatuses
}

function BusinessTravellerStepGroup(props: Props) {
  const { steps, stepStatuses } = props
  const stepsRef = useRef<Record<App.BusinessTraveller.BusinessSignupStepKey, HTMLDivElement | null>>({
    validate_email: null,
    create_customer: null,
    create_business: null,
  })

  useEffect(() => {
    const activeStepEntry = objectEntries(stepStatuses).find(([, status]) => status === 'active')
    if (activeStepEntry) {
      const [activeStep] = activeStepEntry
      const activeElement = stepsRef.current[activeStep]
      if (activeElement) {
        centreElementInView(activeElement)
      }
    }
  }, [stepStatuses])

  return (
    <StepsContainer>
      {steps.map((step, index) =>
        <Group
            direction="horizontal"
            verticalAlign="center"
            key={step.stepKey}
            gap={8}
            ref={(node) => {
              stepsRef.current[step.stepKey] = node
            }}>
          <BusinessTravellerStepCircle status={stepStatuses[step.stepKey]} text={String(index + 1)} />
          <BodyText
              variant="medium"
              wrap="no-wrap"
              colour={stepStatuses[step.stepKey] === 'pending' ? 'neutral-four' : undefined}
              >
            {step.label}
          </BodyText>
          {(index !== steps.length - 1) && <StepLineAngleRightIcon />}
        </Group>,
      )}
    </StepsContainer>
  )
}

export default BusinessTravellerStepGroup
